import BaseEmberPopover from 'ember-tooltips/components/ember-popover';

export default class EmberPopover extends BaseEmberPopover {
  // Setting defaults for ember-popovers
  // Popper.js documentation: https://popper.js.org/docs/v1/
  popperContainer = 'body';

  popperOptions = {
    modifiers: {
      preventOverflow: {
        enabled: true,
        boundariesElement: 'viewport',
        priority: ['left', 'right', 'bottom', 'top'],
        escapeWithReference: false,
      },
    },
  };
}
